import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    defaultWidth: { type: Number, default: 600 },
    maxWidth: { type: Number, default: 600 },
    storageKey: { type: String, default: 'timeline-category-width' }
  }

  connect() {
    this.boundMouseMove = this.mouseMove.bind(this)
    this.boundMouseUp = this.mouseUp.bind(this)
    this.isResizing = false
    this.startX = 0
    this.startWidth = 0
    this.table = this.element.closest('table')

    this.restoreWidth()
  }

  restoreWidth() {
    const savedWidth = localStorage.getItem(this.storageKeyValue)
    const parsedWidth = Number.parseFloat(savedWidth)

    this.setWidth(Number.isFinite(parsedWidth) ? parsedWidth : this.defaultWidthValue)
  }

  get minWidth() {
    return Math.min(window.innerWidth * 0.2, this.maxWidthValue)
  }

  setWidth(width) {
    width = Number.isFinite(width) ? width : this.defaultWidthValue
    width = Math.max(this.minWidth, Math.min(width, this.maxWidthValue))
    this.element.style.width = `${width}px`
    this.element.style.minWidth = `${width}px`
    this.element.style.maxWidth = `${width}px`

    if (this.table) {
      this.table.style.setProperty('--category-col-width', `${width}px`)
      this.table.dispatchEvent(new CustomEvent('timeline:column-resize'))
    }
  }

  startResize(event) {
    event.preventDefault()
    this.isResizing = true
    this.startX = event.clientX

    const rect = this.element.getBoundingClientRect()
    this.startWidth = rect.width

    document.addEventListener('mousemove', this.boundMouseMove)
    document.addEventListener('mouseup', this.boundMouseUp)

    document.body.classList.add('cursor-col-resize', 'select-none')
  }

  mouseMove(event) {
    if (!this.isResizing) return

    const delta = event.clientX - this.startX
    const newWidth = this.startWidth + delta
    this.setWidth(newWidth)
  }

  mouseUp(event) {
    if (!this.isResizing) return
    this.isResizing = false

    document.removeEventListener('mousemove', this.boundMouseMove)
    document.removeEventListener('mouseup', this.boundMouseUp)

    document.body.classList.remove('cursor-col-resize', 'select-none')

    const rect = this.element.getBoundingClientRect()
    localStorage.setItem(this.storageKeyValue, rect.width)
  }
}
